import styled from 'styled-components';

const ChevronWrapper = styled.div`
  float: right;
  margin-right: 17px;
`;

export default ChevronWrapper;
